/* eslint-disable */
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import AuthContext from "../../contexts/AuthProvider";
import { useAIChatFilters } from "../../contexts/AIChatFiltersContext";
import { canUseAIChat } from "../../utils/aiChatAccess";
import { client } from "../../services/axiosClient";
import axios from "axios";
import "moment/locale/es";
import "moment/locale/pt";
import cx from "classnames";
import { Slide, Slide as ToastSlide, toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { useImmer } from "use-immer";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import useThemeColors from "../../hooks/useThemeColors";
import { useScenarios } from "../../hooks/useScenarios";
import ScenarioControls from "../../components/ScenarioControls/ScenarioControls";
import { calculateOomFromPlValues, formatNumber } from "../../utils/utils";
import { computeInitialDrillDowns } from "../../utils/plUtils";
import { useScreenshot, createFileName } from "use-react-screenshot";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRightArrowLeft,
  faArrowTrendDown,
  faArrowTrendUp,
  faCaretDown,
  faCaretUp,
  faChevronDown,
  faChevronUp,
  faClone,
  faCodeCompare,
  faFilter,
  faPenToSquare,
  faScaleBalanced,
  faX,
} from "@fortawesome/free-solid-svg-icons";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";

// @material-ui/icons
import {
  AddCircle,
  AttachMoney,
  BookmarkBorder,
  HelpOutline,
  PhotoCamera,
  Traffic,
} from "@material-ui/icons";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import ModalHeader from "components/ModalHeader";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import FilterTag from "components/FilterTag/FilterTag";
import ActionDropdown from "components/ActionDropdown/ActionDropdown";
import CustomInput from "components/CustomInput/CustomInput";
import ActionBar from "components/ActionBar/ActionBar";
import ActionBarButton from "components/ActionBar/ActionBarButton";
import HelpTooltip from "components/HelpTooltip/HelpTooltip";
import FullPageLoader from "../../components/Loaders/FullPageLoader";
import Pnl from "../../components/Pnl/Pnl";
import ResultsFilterBar, {
  DimDropdown,
} from "../../components/ResultsFilterBar";
import DimFilterDialog from "../../components/ResultsFilterBar/DimFilterDialog";
import PeriodFilterModal, {
  resolvePreset,
} from "../../components/ResultsFilterBar/PeriodFilterModal";
import { useResultsFilters } from "../../hooks/useResultsFilters";
import HelpDialog from "../../components/Dialog/HelpDialog";
import { PnlSharedProvider } from "../../hooks/usePnlShared";

import styles from "../../assets/jss/material-dashboard-pro-react/views/plExplorerStyle";
import ChartistGraph from "react-chartist";
import { linePercentageChart } from "../../variables/charts";

library.add(
  faChevronUp,
  faChevronDown,
  faCaretUp,
  faCaretDown,
  faPenToSquare,
  faFilter,
  faClone,
  faArrowRightArrowLeft,
  faX,
  faArrowTrendUp,
  faArrowTrendDown,
  faCodeCompare,
  faScaleBalanced,
);

const maxPLs = 6;
const refreshPLDelay = 500;

const getIndexes = (filters, values) => {
  return values.map((item) => {
    return filters.indexOf(item);
  });
};

export default function PLExplorer() {
  // #region initial declarations
  let { userDetails } = useContext(AuthContext);
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const { clientColor } = useThemeColors();
  const { t, i18n } = useTranslation();
  const { width, height } = useWindowDimensions();
  const location = useLocation();
  // #endregion

  // #region notify
  const notify = (text, type = "info", time = 3000) =>
    toast(t(text), {
      position: "top-right",
      autoClose: time,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
      type: type,
      transition: ToastSlide,
    });

  const notifyCopy = () =>
    toast(t("results.scenarios.url_sent_to_clipboard"), {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
      type: "info",
      transition: Slide,
    });
  // #endregion

  // #region state declarations
  const filtersList = useRef(["period", "client"]); // init; sobrescrito pelo hook
  const filtersNames = useRef({});
  const filtersItems = useRef({});
  const filtersGroups = useRef({});
  const volumeUnit = useRef(null);
  const [volumeColumn, setVolumeColumn] = useState("volume");
  const volumeUnitAlternatives = useRef([]);
  const currencyUnitOptions = useRef([]);
  const currencyUnitOptionsAvailable = useRef([]);
  const plStructure = useRef([]);
  const netRevenueAnchor = useRef(null);
  const serveMarginAnchor = useRef(null);
  const revenueAnchors = useRef([]);
  const [revenueReference, setRevenueReference] = useState(null);
  const revenueReferenceOptions = useRef([]);
  const combinedAboveAnchor = useRef(null);
  const volumeL12M = useRef(null);
  const initialFiltersObjects = useRef({});
  const initialFiltersStrings = useRef({});

  const plNameInput = useRef(null);
  const timersAllowed = useRef(false);

  const [numPLs, setNumPLs] = useState(0);
  const [oom, setOom] = useState({
    div: 1e6,
    x: " " + t("oom.m"),
  });
  const [manualOom, setManualOom] = useState("auto");

  const [currencyUnit, setCurrencyUnit] = useState(null);
  const [showValueType, setShowValueType] = useState("value");
  const [benchmark, setBenchmark] = useState("total_company");

  const [plsToRefresh, setPlsToRefresh] = useState([]);
  const [plsOnError, setPlsOnError] = useState([]);
  const [comparisonLoading, setComparisonLoading] = useState(false);
  const [drillDownsOpen, setDrillDownsOpen] = useState([]);

  const [plNameModalOpen, setPlNameModalOpen] = useState(false);
  const [plNames, setPlNames] = useImmer({ 1: "" });
  const [plNameModalCurrentNum, setPLNameModalCurrentNum] = useState(0);
  const [plNameModalInput, setPlNameModalInput] = useState("");
  const [plShow, setPlShow] = useState([]);

  // Auto-naming state
  const [isAutoName, setIsAutoName] = useImmer({ 1: true });
  const [namingPlaceholderPL, setNamingPlaceholderPL] = useState(null);
  const namingController = useRef(null);
  const namingDebounceTimer = useRef(null);
  const [namingTrigger, setNamingTrigger] = useState({ seq: 0, pl: null });

  const [plValues, setPlValues] = useImmer({});

  // per-PnL filter state (kept locally — hook manages common filters only)
  const [plFilters, setPlFilters] = useImmer({});
  const [plFiltersIndexes, setPlFiltersIndexes] = useImmer({});
  const [plFiltersMode, setPlFiltersMode] = useImmer({});
  const [plFiltersSequence, setPlFiltersSequence] = useImmer({ 1: [] });
  // range filters por P&L individual: { [numPL]: { [dimension]: { mode, min, max, refLine, label } } }
  const [plRangeFilters, setPlRangeFilters] = useImmer({});
  // Items ainda disponíveis após aplicar filtros comuns (para grey-out no modal por PL)
  const [availableItemsAfterCommon, setAvailableItemsAfterCommon] =
    useState(null);
  const [truncatedDimensions, setTruncatedDimensions] = useState([]);
  // Filtro de período por PL individual: { [numPL]: { tuples: [[y,m],...], keys: Set<"y-m"> } }
  const [plPeriodFilters, setPlPeriodFilters] = useImmer({});
  const [plPeriodModalOpen, setPlPeriodModalOpen] = useState(false);
  const [plPeriodModalPl, setPlPeriodModalPl] = useState(null);

  // PL-scope filter modal state (separate from hook's common filter modal)
  const [plFilterModalOpen, setPlFilterModalOpen] = useState(false);
  const [plFilterModalCurrentFilter, setPlFilterModalCurrentFilter] =
    useState("");
  const [plFilterModalCurrentPl, setPlFilterModalCurrentPl] = useState(0);

  // metaLoaded is provided by useResultsFilters below
  const [metaLoaded, setMetaLoaded] = useState(false);

  const [refreshDelayHandler, setRefreshDelayHandler] = useImmer({
    1: {
      delay_handler: null,
      controller: new AbortController(),
    },
  });
  const [mouseOverPLLine, setMouseOverPLLine] = useState(null);
  const [mouseOverPLLineFade, setMouseOverPLLineFade] = useState(null);

  const useThreeColumns = useMemo(() => {
    if (numPLs <= 3) return true;
    if (numPLs === 4) return width >= 1600;
    return false;
  }, [numPLs, width]);

  const [plValDetailsPl, setPlValDetailsPl] = useState(1);
  const [plValDetailsName, setPlValDetailsName] = useState(null);
  const [plValDetailsVars, setPlValDetailsVars] = useState([]);
  const [plValDetailsPromoters, setPlValDetailsPromoters] = useState({});
  const [plValDetailsDetractors, setPlValDetailsDetractors] = useState({});
  const [detailsMonthlyEvolution, setDetailsMonthlyEvolution] = useState({
    ...linePercentageChart,
    data: {
      labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      series: [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
    },
  });
  const [loadingPlValDetails, setLoadingPlValDetails] = useState(false);

  const [helpDialogOpen, setHelpDialogOpen] = useState(false);

  const resultsRef = useRef(null);
  // #endregion

  // ── useResultsFilters — common filters + metadata ─────────────────────────
  // Callback ref populated below (after hook call) to avoid closure stale refs
  const plExplorerMetaCallback = useRef(null);
  const {
    filtersList: _filtersList,
    filtersNames: _filtersNames,
    filtersItems: _filtersItems,
    filtersGroups: _filtersGroups,
    metaLoaded: hookMetaLoaded,
    commonFilters,
    setCommonFilters,
    commonFiltersIndexes,
    setCommonFiltersIndexes,
    commonFiltersMode,
    setCommonFiltersMode,
    commonFiltersSequence,
    setCommonFiltersSequence,
    filterMenuClickHandler: hookFilterMenuClickHandler,
    removeFilter,
    dimFilterDialogProps,
    filtersListTranslated,
    filtersActiveList: filtersActiveListHook,
    filtersSequenceNums: filtersSequenceNumsHook,
    getFiltersInSequence,
    getDimInfo,
    getFilterItems,
    getChoicesList,
    handleResetFilters,
    dimSections,
    persist,
    setPersist,
    availablePeriods,
    selectedPeriodKeys,
    activePreset,
    handlePeriodApply,
    rangeFilters,
    clearRangeFilter,
  } = useResultsFilters({
    metaEndpoint: "api/results_pl_explorer_meta/",
    getDimInfoExtra: () => ({
      hasRefRange: true,
      plLines: plStructure.current.map((l) => ({
        key: l.meta_name,
        label: l.name,
        level: l.level,
        isParent: l.is_parent,
      })),
      serveMarginAnchor: serveMarginAnchor.current,
      revenueAnchors: revenueAnchors.current,
    }),
    onMetaLoaded: (response) => plExplorerMetaCallback.current?.(response),
  });
  // Sync hook refs into PLExplorer refs so existing code keeps working
  filtersList.current = _filtersList.current;
  filtersNames.current = _filtersNames.current;
  filtersItems.current = _filtersItems.current;
  filtersGroups.current = _filtersGroups.current;
  // Expose hook metaLoaded via the local state var
  // (kept for compatibility with existing useEffect deps)
  useEffect(() => {
    if (hookMetaLoaded) setMetaLoaded(true);
  }, [hookMetaLoaded]);

  // ── useScenarios — centralized scenario management ──────────────────────
  const scenarioHook = useScenarios({
    viewType: "pl_explorer",
    buildPayload: useCallback(
      () => ({
        numPLs,
        commonFilters,
        commonFiltersMode,
        commonFiltersSequence,
        plFilters,
        plFiltersMode,
        plFiltersSequence,
        plNames,
        isAutoName,
        currencyUnit,
        showValueType,
        manualOom,
      }),
      [
        numPLs, commonFilters, commonFiltersMode, commonFiltersSequence,
        plFilters, plFiltersMode, plFiltersSequence,
        plNames, isAutoName, currencyUnit, showValueType, manualOom,
      ],
    ),
    applyPayload: useCallback(
      (data) => {
        setCommonFilters(data.commonFilters);
        setCommonFiltersMode(data.commonFiltersMode);
        setCommonFiltersSequence(data.commonFiltersSequence);
        const cfIndexes = {};
        filtersList.current.forEach((filter) => {
          if (data.commonFiltersMode[filter] === "group") {
            cfIndexes[filter] = getIndexes(
              Object.keys(filtersGroups.current[filter] || {}),
              data.commonFilters[filter] || [],
            );
          } else if (data.commonFiltersMode[filter] === "items") {
            cfIndexes[filter] = getIndexes(
              filtersItems.current[filter] || [],
              data.commonFilters[filter] || [],
            );
          } else {
            cfIndexes[filter] = [];
          }
        });
        setCommonFiltersIndexes(cfIndexes);
        if (data.plFilters) {
          setPlFilters(data.plFilters);
          setPlFiltersMode(data.plFiltersMode);
          setPlFiltersSequence(data.plFiltersSequence);
          const pfIndexes = {};
          Object.keys(data.plFilters).forEach((numPL) => {
            pfIndexes[numPL] = {};
            filtersList.current.forEach((filter) => {
              if (data.plFiltersMode[numPL]?.[filter] === "group") {
                pfIndexes[numPL][filter] = getIndexes(
                  Object.keys(filtersGroups.current[filter] || {}),
                  data.plFilters[numPL][filter] || [],
                );
              } else if (data.plFiltersMode[numPL]?.[filter] === "items") {
                pfIndexes[numPL][filter] = getIndexes(
                  filtersItems.current[filter] || [],
                  data.plFilters[numPL][filter] || [],
                );
              } else {
                pfIndexes[numPL][filter] = [];
              }
            });
          });
          setPlFiltersIndexes(pfIndexes);
        }
        if (data.plNames) setPlNames(data.plNames);
        if (data.isAutoName) {
          setIsAutoName(data.isAutoName);
        } else if (data.numPLs && data.plNames) {
          const autoNameInit = {};
          for (let i = 1; i <= data.numPLs; i++) {
            autoNameInit[i] = !data.plNames[i];
          }
          setIsAutoName(autoNameInit);
        }
        if (data.currencyUnit) setCurrencyUnit(data.currencyUnit);
        if (data.showValueType) setShowValueType(data.showValueType);
        setManualOom(data.manualOom || "auto");
        if (data.numPLs) {
          setNumPLs(data.numPLs);
          setPlShow([...Array(data.numPLs).keys()].map((i) => i + 1));
          const blankObjects = {};
          [...Array(data.numPLs)].map((_, i) => (blankObjects[i + 1] = {}));
          setPlValues(blankObjects);
          setPlsToRefresh([...Array(data.numPLs)].map((_, i) => i + 1));
          [...Array(data.numPLs)].map((_, i) => {
            refreshPL(
              i + 1,
              data.commonFilters,
              data.commonFiltersMode,
              data.commonFiltersSequence,
              data.plFilters?.[i + 1],
              data.plFiltersMode?.[i + 1],
              data.plFiltersSequence?.[i + 1],
              true,
              data.currencyUnit,
            );
          });
        }
      },
      [], // eslint-disable-line
    ),
    t,
    notify,
  });

  // Períodos concretos selecionados no filtro comum (para restringir modal por PL)
  const commonPeriodConcrete = useMemo(() => {
    if (!availablePeriods || availablePeriods.length === 0) return [];
    const allKeys = availablePeriods.map((p) => `${p.year}-${p.month}`);
    if (selectedPeriodKeys && selectedPeriodKeys.size > 0) {
      return availablePeriods.filter(
        (p) => selectedPeriodKeys.has(`${p.year}-${p.month}`),
      );
    }
    if (activePreset) {
      const resolved = resolvePreset(activePreset, allKeys);
      return availablePeriods.filter(
        (p) => resolved.has(`${p.year}-${p.month}`),
      );
    }
    return availablePeriods;
  }, [availablePeriods, selectedPeriodKeys, activePreset]);

  const commonScopeKeySet = useMemo(
    () => new Set(commonPeriodConcrete.map((p) => `${p.year}-${p.month}`)),
    [commonPeriodConcrete],
  );

  // #region functions
  // eslint-disable-next-line no-unused-vars
  const [image, takeScreenShot] = useScreenshot({
    type: "image/png",
    quality: 1.0,
  });
  const download = (
    image,
    { name = "results_screenshot", extension = "png" } = {},
  ) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };
  const downloadScreenshot = () =>
    takeScreenShot(resultsRef.current).then(download);
  const getUnitOptions = () => {
    let options = [];
    // currencies
    options.push({
      explainer: true,
      text: t("results.unit_blocks.currency"),
    });
    currencyUnitOptions.current.map((opt) => {
      let available = currencyUnitOptionsAvailable.current.includes(opt);
      options.push({
        identified: {
          option_type: "currency",
          value: opt,
        },
        text:
          opt +
          (available
            ? ""
            : " (" +
              t("results.missing_rates") +
              (["DEV", "IMG", "CAD", "CFA", "CST"].includes(
                userDetails.user_role,
              )
                ? " - " + t("results.missing_rates_complement")
                : "") +
              ")"),
        active: opt === currencyUnit,
        disabled: !available,
      });
    });
    // revenue reference (only show if more than 1 option)
    if (revenueReferenceOptions.current.length > 1) {
      options.push({ divider: true });
      options.push({
        explainer: true,
        text: (
          <span>
            {t("results.unit_blocks.revenue_reference")}{" "}
            <HelpTooltip
              small
              tooltip={t("results.unit_blocks.revenue_reference_tooltip")}
            />
          </span>
        ),
      });
      revenueReferenceOptions.current.forEach((opt) => {
        options.push({
          identified: {
            option_type: "revenue_reference",
            value: opt.value,
          },
          text:
            opt.value === "combined" ? (
              <span>
                {t("results.unit_blocks.combined")}{" "}
                <HelpTooltip
                  small
                  tooltip={(() => {
                    const refs = revenueReferenceOptions.current.filter(
                      (o) => o.value !== "combined",
                    );
                    const first = refs[0]?.label || "";
                    const last = refs[refs.length - 1]?.label || "";
                    return `${first} ${t("results.unit_blocks.combined_above")} / ${last} ${t("results.unit_blocks.combined_below")}`;
                  })()}
                />
              </span>
            ) : (
              opt.label
            ),
          active: revenueReference === opt.value,
        });
      });
    }
    // volume unit alternatives (only show if more than 1 option)
    if (volumeUnitAlternatives.current.length > 1) {
      options.push({ divider: true });
      options.push({
        explainer: true,
        text: t("results.unit_blocks.volume"),
      });
      volumeUnitAlternatives.current.forEach((opt) => {
        options.push({
          identified: {
            option_type: "volume",
            value: opt.column,
          },
          text: opt.label,
          active: volumeColumn === opt.column,
        });
      });
    }
    if (!useThreeColumns) {
      options.push({ divider: true });
      options.push({
        explainer: true,
        text: t("results.unit_blocks.value"),
      });
      // nominal value
      options.push({
        identified: {
          option_type: "value_type",
          value: "value",
        },
        text: t("results.nominal_value"),
        active: showValueType === "value",
      });
      // value / unit
      options.push({
        identified: {
          option_type: "value_type",
          value: "per_unit",
        },
        text: t("results.value") + " / " + volumeUnit.current,
        active: showValueType === "per_unit",
      });
    }
    options.push({ divider: true });
    // order of magnitude
    options.push({
      explainer: true,
      text: t("results.unit_blocks.scale"),
    });
    options.push({
      identified: {
        option_type: "oom",
        value: "auto",
      },
      text: t("oom.auto"),
      active: manualOom === "auto",
    });
    options.push({
      identified: {
        option_type: "oom",
        value: "units",
      },
      text: t("oom.units"),
      active: manualOom === "units",
    });
    options.push({
      identified: {
        option_type: "oom",
        value: "thousands",
      },
      text: t("oom.thousands"),
      active: manualOom === "thousands",
    });
    options.push({
      identified: {
        option_type: "oom",
        value: "millions",
      },
      text: t("oom.millions"),
      active: manualOom === "millions",
    });
    options.push({
      identified: {
        option_type: "oom",
        value: "billions",
      },
      text: t("oom.billions"),
      active: manualOom === "billions",
    });
    return options;
  };
  const benchmarkOptions = useMemo(() => {
    let options = [];
    options.push({
      identified: { value: "total_company" },
      text: t("results.total_company"),
      active: benchmark === "total_company",
    });
    options.push({
      identified: { value: "first_pnl" },
      text: t("results.first_pnl"),
      active: benchmark === "first_pnl",
    });
    options.push({
      identified: { value: "external" },
      text: t("results.external"),
      active: benchmark === "external",
      disabled: true,
    });
    return options;
  }, [t, benchmark]);

  // filtersListTranslated, getFilterItems, getChoicesList → fornecidos por useResultsFilters

  const getFilterScopeData = useCallback(() => {
    const scopeData = {
      viewType: "pl_explorer",
    };

    // Process each P&L
    Object.keys(plValues).forEach((numPL) => {
      const activeFilters = [];

      // Get common filters (excluding period)
      commonFiltersSequence.forEach((filterName) => {
        if (filterName === "period") return;

        // Check if the filter has items (same logic as FilterTag)
        const filterItems = getFilterItems(
          commonFilters[filterName] || [],
          filterName,
          commonFiltersMode[filterName],
        );

        if (filterItems && filterItems.length > 0) {
          // Get the translated name directly from filtersNames
          const translatedName = Object.keys(filtersNames.current).includes(
            filterName,
          )
            ? filtersNames.current[filterName][i18n.language]
            : filterName;

          activeFilters.push({
            name: translatedName,
            type: "common",
            filterName: filterName,
            items: filterItems,
          });
        }
      });

      // Get P&L specific filters (excluding period)
      if (plFiltersSequence[numPL]) {
        plFiltersSequence[numPL].forEach((filterName) => {
          if (filterName === "period") return;

          // Check if the filter has items (same logic as FilterTag)
          const filterItems = getFilterItems(
            plFilters[numPL]?.[filterName] || [],
            filterName,
            plFiltersMode[numPL]?.[filterName],
          );

          if (filterItems && filterItems.length > 0) {
            // Get the translated name directly from filtersNames
            const translatedName = Object.keys(filtersNames.current).includes(
              filterName,
            )
              ? filtersNames.current[filterName][i18n.language]
              : filterName;

            activeFilters.push({
              name: translatedName,
              type: "pl_specific",
              filterName: filterName,
              items: filterItems,
            });
          }
        });
      }

      scopeData[numPL] = activeFilters;
    });

    return scopeData;
  }, [
    plValues,
    commonFiltersSequence,
    commonFilters,
    commonFiltersMode,
    plFiltersSequence,
    plFilters,
    plFiltersMode,
    filtersNames,
    i18n.language,
    getFilterItems,
  ]);
  const {
    setPageFilters: _setChatFilters,
    clearPageFilters: _clearChatFilters,
    setChatOverride: _setChatOverride,
    requestOpenChat,
  } = useAIChatFilters();
  useEffect(() => {
    const summary = [];
    commonFiltersSequence.forEach((filterName) => {
      const items = commonFilters[filterName] || [];
      if (items.length === 0) return;
      const label =
        filtersNames.current[filterName]?.[i18n.language] || filterName;
      const values = getFilterItems(
        items,
        filterName,
        commonFiltersMode[filterName],
      );
      if (values && values.length > 0) {
        summary.push({ dimension: label, values });
      }
    });
    _setChatFilters("PL Explorer", summary);
    return () => _clearChatFilters();
  }, [commonFilters, commonFiltersMode, commonFiltersSequence, i18n.language]);

  const openChatWithPLFilters = useCallback(
    (numPL) => {
      const summary = [];
      commonFiltersSequence.forEach((filterName) => {
        const items = commonFilters[filterName] || [];
        if (items.length === 0) return;
        const label =
          filtersNames.current[filterName]?.[i18n.language] || filterName;
        const values = getFilterItems(
          items,
          filterName,
          commonFiltersMode[filterName],
        );
        if (values && values.length > 0) {
          summary.push({ dimension: label, values });
        }
      });
      if (plFiltersSequence[numPL]) {
        plFiltersSequence[numPL].forEach((filterName) => {
          if (filterName === "period") return;
          const items = plFilters[numPL]?.[filterName] || [];
          if (items.length === 0) return;
          const label =
            filtersNames.current[filterName]?.[i18n.language] || filterName;
          const values = getFilterItems(
            items,
            filterName,
            plFiltersMode[numPL]?.[filterName],
          );
          if (values && values.length > 0) {
            summary.push({ dimension: label, values });
          }
        });
      }
      const plLabel = plNames[numPL] || `PL ${numPL}`;
      _setChatOverride(`PL Explorer — ${plLabel}`, summary);
      requestOpenChat();
    },
    [
      commonFiltersSequence,
      commonFilters,
      commonFiltersMode,
      plFiltersSequence,
      plFilters,
      plFiltersMode,
      plNames,
      filtersNames,
      i18n.language,
      _setChatOverride,
      requestOpenChat,
    ],
  );

  // filtersActiveList for common scope is available via filtersActiveListHook
  const filtersActiveListPL = useCallback(
    (scope, numPL) =>
      filtersList.current.reduce((acc, filter, key) => {
        if (
          plFilters[numPL] &&
          plFilters[numPL][filter] &&
          plFilters[numPL][filter].length > 0
        )
          acc.push(key);
        return acc;
      }, []),
    [plFilters],
  );
  const filtersSequence = useCallback(
    (numPL) => {
      if (numPL === "common") {
        return filtersSequenceNumsHook();
      } else {
        return filtersList.current.map((filter) => {
          return plFiltersSequence[numPL].indexOf(filter) === -1
            ? ""
            : plFiltersSequence[numPL].indexOf(filter) > 9
              ? "N"
              : (plFiltersSequence[numPL].indexOf(filter) + 1).toString();
        });
      }
    },
    [filtersSequenceNumsHook, filtersList, plFiltersSequence],
  );
  const removeCommonFilter = (filter, item, index, all = false) => {
    let new_filter_items;
    if (filter === "period" && commonFiltersMode[filter] === "items") {
      let month_item = filtersItems.current[filter][index];
      new_filter_items = all
        ? []
        : commonFilters[filter].filter(
            (items) => JSON.stringify(items) !== JSON.stringify(month_item),
          );
    } else {
      new_filter_items = all
        ? []
        : commonFilters[filter].filter((items) => items !== item);
    }

    if (filter === "period" && new_filter_items.length === 0) {
      notify(
        "results.toasts.you_must_keep_at_least_one_period_filter",
        "warning",
      );
      return;
    }
    let common_filters = {
      ...commonFilters,
      [filter]: new_filter_items,
    };
    let common_filters_mode = commonFiltersMode;
    setCommonFilters((draft) => {
      draft[filter] = new_filter_items;
    });
    let common_filters_sequence = commonFiltersSequence;
    if (new_filter_items.length === 0) {
      setCommonFiltersIndexes((draft) => {
        draft[filter] = [];
      });
      common_filters_mode = {
        ...commonFiltersMode,
        [filter]: "",
      };
      setCommonFiltersMode((draft) => {
        draft[filter] = "";
      });
      common_filters_sequence = commonFiltersSequence.filter(
        (f) => f !== filter,
      );
      setCommonFiltersSequence(common_filters_sequence);
    } else {
      setCommonFiltersIndexes((draft) => {
        draft[filter] = commonFiltersIndexes[filter].filter(
          (indexes) => indexes !== index,
        );
      });
    }
    setPlsToRefresh(Object.keys(plValues).map((val) => parseInt(val)));
    Object.keys(plValues).map((numPL) => {
      refreshPL(
        numPL,
        common_filters,
        common_filters_mode,
        common_filters_sequence,
        plFilters[numPL],
        plFiltersMode[numPL],
        plFiltersSequence[numPL],
      );
    });
  };
  // getChoicesList → fornecido por useResultsFilters (como `getChoicesList`)
  // filterMenuClickHandler for common scope → use hookFilterMenuClickHandler
  const filterMenuClickHandler = (scope, numPL) => (event) => {
    if (scope === "common") {
      return hookFilterMenuClickHandler()(event);
    }
    // PL scope
    const selectedFilter =
      typeof event === "string" ? event : filtersList.current[event];
    setPlFilterModalCurrentFilter(selectedFilter);
    setPlFilterModalCurrentPl(numPL);
    setPlFilterModalOpen(true);
  };
  const getFiltersNamesInSequence = (scope) => {
    if (scope === "common") {
      return commonFiltersSequence.filter((f) =>
        Object.keys(filtersNames.current).includes(f),
      );
    } else {
      return plFiltersSequence[scope].filter((f) =>
        Object.keys(filtersNames.current).includes(f),
      );
    }
  };
  const refreshPL = (
    numPL,
    common_filters = commonFilters,
    common_filters_mode = commonFiltersMode,
    common_filters_sequence = commonFiltersSequence,
    pl_filters = plFilters[numPL],
    pl_filters_mode = plFiltersMode[numPL],
    pl_filters_sequence = plFiltersSequence[numPL],
    immediate = false,
    currency_unit = currencyUnit,
    volume_column = volumeColumn,
    override_range_filters = null,
    override_period_tuples = undefined,
  ) => {
    if (!pl_filters) return false; // avoids calling API during load
    if (
      refreshDelayHandler[numPL] &&
      refreshDelayHandler[numPL].delay_handler
    ) {
      clearTimeout(refreshDelayHandler[numPL].delay_handler);
      refreshDelayHandler[numPL].controller.abort();
    }
    let controller = new AbortController();
    // Substitui o período comum pelo período específico do PL, se houver
    // Intersecta com o escopo comum para que períodos fora do alcance resultem em zero
    const rawPeriodTuples =
      override_period_tuples !== undefined
        ? override_period_tuples
        : plPeriodFilters[numPL]?.tuples ?? null;
    const periodTuples = rawPeriodTuples
      ? rawPeriodTuples.filter((t) => commonScopeKeySet.has(`${t[0]}-${t[1]}`))
      : null;
    const effective_common_filters =
      periodTuples && periodTuples.length > 0
        ? { ...common_filters, period: periodTuples }
        : periodTuples // length === 0 → fora do escopo, forçar sem dados
          ? { ...common_filters, period: [[-1, -1]] }
          : common_filters;
    const effective_common_filters_mode =
      periodTuples
        ? { ...common_filters_mode, period: "items" }
        : common_filters_mode;

    let params = {
      currency_unit,
      common_filters: effective_common_filters,
      common_filters_mode: effective_common_filters_mode,
      common_filters_sequence,
      pl_filters,
      pl_filters_mode,
      pl_filters_sequence,
      ref_range_filters: (() => {
        if (override_range_filters !== null)
          return override_range_filters.length > 0 ? override_range_filters : null;
        const globalArr = Object.entries(rangeFilters).map(([dim, f]) => ({
          dimension: dim,
          mode: f.mode,
          min: f.min,
          max: f.max,
          ref_line: f.refLine,
        }));
        const plArr = Object.entries(
          plRangeFilters[numPL] || {},
        ).map(([dim, f]) => ({
          dimension: dim,
          mode: f.mode,
          min: f.min,
          max: f.max,
          ref_line: f.refLine,
        }));
        const merged = [...globalArr, ...plArr];
        return merged.length > 0 ? merged : null;
      })(),
      ref_color_line:
        Object.keys(rangeFilters).length > 0
          ? Object.values(rangeFilters)[0]?.refLine || null
          : Object.values(plRangeFilters[numPL] || {})[0]?.refLine || null,
      volume_column,
      revenue_reference: revenueReference,
    };
    setPlsOnError((plsOnError) =>
      plsOnError.filter((item) => item !== parseInt(numPL)),
    );
    setRefreshDelayHandler((draft) => {
      draft[numPL] = {
        delay_handler: setTimeout(
          () => {
            client
              .post("api/results_pl_explorer_read_pl/", params, {
                signal: controller.signal,
              })
              .then((response) => {
                setPlValues((draft) => {
                  draft[numPL] = response.data.pl;
                });
                setPlsToRefresh((plsToRefresh) =>
                  plsToRefresh.filter((item) => item !== parseInt(numPL)),
                );
              })
              .catch((error) => {
                if (!axios.isCancel(error)) {
                  setPlsOnError((plsOnError) =>
                    plsOnError.includes(parseInt(numPL))
                      ? plsOnError
                      : [...plsOnError, parseInt(numPL)],
                  );
                  setPlsToRefresh((plsToRefresh) =>
                    plsToRefresh.filter((item) => item !== parseInt(numPL)),
                  );
                  console.log(error);
                }
              });
          },
          immediate ? 0 : refreshPLDelay,
        ),
        controller: controller,
      };
    });
  };
  const addPL = useCallback(
    (clone_pl = 0) => {
      if (numPLs >= maxPLs) return false;
      if (plsToRefresh.length > 0) return false;
      if (clone_pl > 0) {
        let newNumPLs = numPLs + 1;
        let new_pl_values = {};
        let new_pl_filters_indexes = {};
        let new_pl_filters = {};
        let new_pl_filters_mode = {};
        let new_pl_filters_sequence = {};
        let new_pl_names = {};
        for (let numPL = newNumPLs; numPL > clone_pl; numPL--) {
          new_pl_values = {
            ...new_pl_values,
            [numPL]: plValues[numPL - 1],
          };
          new_pl_filters_indexes = {
            ...new_pl_filters_indexes,
            [numPL]: plFiltersIndexes[numPL - 1],
          };
          new_pl_filters = {
            ...new_pl_filters,
            [numPL]: plFilters[numPL - 1],
          };
          new_pl_filters_mode = {
            ...new_pl_filters_mode,
            [numPL]: plFiltersMode[numPL - 1],
          };
          new_pl_filters_sequence = {
            ...new_pl_filters_sequence,
            [numPL]: plFiltersSequence[numPL - 1],
          };
          if (numPL === clone_pl + 1) {
            new_pl_names = {
              ...new_pl_names,
              [numPL]: "",
            };
          } else {
            new_pl_names = {
              ...new_pl_names,
              [numPL]: plNames[numPL - 1],
            };
          }
        }
        setPlValues((draft) => {
          Object.entries(new_pl_values).forEach(
            ([key, val]) => (draft[key] = val),
          );
        });
        setPlFiltersIndexes((draft) => {
          Object.entries(new_pl_filters_indexes).forEach(
            ([key, val]) => (draft[key] = val),
          );
        });
        setPlFilters((draft) => {
          Object.entries(new_pl_filters).forEach(
            ([key, val]) => (draft[key] = val),
          );
        });
        setPlFiltersMode((draft) => {
          Object.entries(new_pl_filters_mode).forEach(
            ([key, val]) => (draft[key] = val),
          );
        });
        setPlFiltersSequence((draft) => {
          Object.entries(new_pl_filters_sequence).forEach(
            ([key, val]) => (draft[key] = val),
          );
        });
        setPlNames((draft) => {
          Object.entries(new_pl_names).forEach(
            ([key, val]) => (draft[key] = val),
          );
        });
        setIsAutoName((draft) => {
          for (let numPL = newNumPLs; numPL > clone_pl; numPL--) {
            if (numPL === clone_pl + 1) {
              draft[numPL] = true;
            } else {
              draft[numPL] = isAutoName[numPL - 1] ?? true;
            }
          }
        });
        setRefreshDelayHandler((draft) => {
          draft[newNumPLs] = {
            delay_handler: null,
            controller: new AbortController(),
          };
        });
        setNumPLs(newNumPLs);
        setPlShow(
          [...Array(newNumPLs).keys()]
            .map((i) => i + 1)
            .filter((pl) => pl !== clone_pl + 1),
        );
        setTimeout(
          () => setPlShow((pls) => [...pls, clone_pl + 1]),
          clone_pl + 1 === newNumPLs ? 0 : 200,
        );
      } else {
        let newNumPLs = numPLs + 1;
        setPlValues((draft) => {
          draft[newNumPLs] = {};
        });
        setPlFiltersIndexes((draft) => {
          draft[newNumPLs] = initialFiltersObjects.current;
        });
        setPlFilters((draft) => {
          draft[newNumPLs] = initialFiltersObjects.current;
        });
        setPlFiltersMode((draft) => {
          draft[newNumPLs] = initialFiltersStrings.current;
        });
        setPlFiltersSequence((draft) => {
          draft[newNumPLs] = [];
        });
        setPlNames((draft) => {
          draft[newNumPLs] = "";
        });
        setIsAutoName((draft) => {
          draft[newNumPLs] = true;
        });
        setRefreshDelayHandler((draft) => {
          draft[newNumPLs] = {
            delay_handler: null,
            controller: new AbortController(),
          };
        });
        setNumPLs(newNumPLs);
        setTimeout(
          () => setPlShow([...Array(newNumPLs).keys()].map((i) => i + 1)),
          0,
        );
        setPlsToRefresh([...plsToRefresh, newNumPLs]);
        refreshPL(
          newNumPLs,
          commonFilters,
          commonFiltersMode,
          commonFiltersSequence,
          initialFiltersObjects.current,
          initialFiltersStrings.current,
          [],
        );
      }
    },
    [
      numPLs,
      maxPLs,
      plsToRefresh,
      plValues,
      plFiltersIndexes,
      plFilters,
      plFiltersMode,
      plFiltersSequence,
      plNames,
      initialFiltersObjects,
      initialFiltersStrings,
      setPlValues,
      setPlFiltersIndexes,
      setPlFilters,
      setPlFiltersMode,
      setPlFiltersSequence,
      setPlNames,
      setRefreshDelayHandler,
      setNumPLs,
      setPlShow,
      setPlsToRefresh,
      refreshPL,
      commonFilters,
      commonFiltersMode,
      commonFiltersSequence,
    ],
  );
  const removePL = useCallback(
    (removePL) => {
      if (numPLs === 1) return false;
      if (plsToRefresh.length > 0) return false;
      let newNumPLs = numPLs - 1;
      let new_pl_values = {};
      let new_pl_filters_indexes = {};
      let new_pl_filters = {};
      let new_pl_filters_mode = {};
      let new_pl_filters_sequence = {};
      let new_pl_period_filters = {};
      let new_pl_range_filters = {};
      let new_pl_names = {};
      for (let numPL = removePL; numPL <= newNumPLs; numPL++) {
        new_pl_values = {
          ...new_pl_values,
          [numPL]: plValues[numPL + 1],
        };
        new_pl_filters_indexes = {
          ...new_pl_filters_indexes,
          [numPL]: plFiltersIndexes[numPL + 1],
        };
        new_pl_filters = {
          ...new_pl_filters,
          [numPL]: plFilters[numPL + 1],
        };
        new_pl_filters_mode = {
          ...new_pl_filters_mode,
          [numPL]: plFiltersMode[numPL + 1],
        };
        new_pl_filters_sequence = {
          ...new_pl_filters_sequence,
          [numPL]: plFiltersSequence[numPL + 1] || [],
        };
        new_pl_period_filters = {
          ...new_pl_period_filters,
          ...(plPeriodFilters[numPL + 1]
            ? { [numPL]: plPeriodFilters[numPL + 1] }
            : {}),
        };
        new_pl_range_filters = {
          ...new_pl_range_filters,
          ...(plRangeFilters[numPL + 1]
            ? { [numPL]: plRangeFilters[numPL + 1] }
            : {}),
        };
        new_pl_names = {
          ...new_pl_names,
          [numPL]: plNames[numPL + 1],
        };
      }
      setPlValues((draft) => {
        Object.entries(new_pl_values).forEach(
          ([key, val]) => (draft[key] = val),
        );
        delete draft[newNumPLs + 1];
      });
      setPlFiltersIndexes((draft) => {
        Object.entries(new_pl_filters_indexes).forEach(
          ([key, val]) => (draft[key] = val),
        );
        delete draft[newNumPLs + 1];
      });
      setPlFilters((draft) => {
        Object.entries(new_pl_filters).forEach(
          ([key, val]) => (draft[key] = val),
        );
        delete draft[newNumPLs + 1];
      });
      setPlFiltersMode((draft) => {
        Object.entries(new_pl_filters_mode).forEach(
          ([key, val]) => (draft[key] = val),
        );
        delete draft[newNumPLs + 1];
      });
      setPlFiltersSequence((draft) => {
        Object.entries(new_pl_filters_sequence).forEach(
          ([key, val]) => (draft[key] = val),
        );
        delete draft[newNumPLs + 1];
      });
      setPlPeriodFilters((draft) => {
        for (let numPL = removePL; numPL <= newNumPLs; numPL++) {
          if (new_pl_period_filters[numPL]) {
            draft[numPL] = new_pl_period_filters[numPL];
          } else {
            delete draft[numPL];
          }
        }
        delete draft[newNumPLs + 1];
      });
      setPlRangeFilters((draft) => {
        for (let numPL = removePL; numPL <= newNumPLs; numPL++) {
          if (new_pl_range_filters[numPL]) {
            draft[numPL] = new_pl_range_filters[numPL];
          } else {
            delete draft[numPL];
          }
        }
        delete draft[newNumPLs + 1];
      });
      setPlNames((draft) => {
        Object.entries(new_pl_names).forEach(
          ([key, val]) => (draft[key] = val),
        );
        delete draft[newNumPLs + 1];
      });
      setIsAutoName((draft) => {
        for (let numPL = removePL; numPL <= newNumPLs; numPL++) {
          draft[numPL] = isAutoName[numPL + 1] ?? true;
        }
        delete draft[newNumPLs + 1];
      });
      setNumPLs(newNumPLs);
      setPlShow([...Array(newNumPLs).keys()].map((i) => i + 1));
      setNamingTrigger((prev) => ({ seq: prev.seq + 1, pl: null }));
    },
    [
      numPLs,
      plsToRefresh,
      plValues,
      plFiltersIndexes,
      plFilters,
      plFiltersMode,
      plFiltersSequence,
      plPeriodFilters,
      plRangeFilters,
      plNames,
      isAutoName,
      setPlValues,
      setPlFiltersIndexes,
      setPlFilters,
      setPlFiltersMode,
      setPlNames,
      setNumPLs,
      setPlShow,
    ],
  );
  const retryPL = useCallback(
    (numPL) => {
      setPlsToRefresh((plsToRefresh) => [...plsToRefresh, numPL]);
      setPlsOnError((plsOnError) =>
        plsOnError.filter((item) => item !== parseInt(numPL)),
      );
      refreshPL(
        numPL,
        commonFilters,
        commonFiltersMode,
        commonFiltersSequence,
        plFilters[numPL],
        plFiltersMode[numPL],
        plFiltersSequence[numPL],
        true,
      );
    },
    [
      refreshPL,
      commonFilters,
      commonFiltersMode,
      commonFiltersSequence,
      plFilters,
      plFiltersMode,
      plFiltersSequence,
    ],
  );
  const clearTimeouts = useCallback(() => {
    // Removed mouse over timers - no longer needed
  }, []);
  const allowTimers = useCallback(() => {
    timersAllowed.current = true;
  }, []);
  const disallowTimers = useCallback(() => {
    timersAllowed.current = false;
    clearTimeouts();
  }, [clearTimeouts]);
  const getPlValName = (meta_name) => {
    const getName = (mn) => {
      let _name, _parent;
      plStructure.current.forEach((item) => {
        if (item.meta_name === mn) {
          _name = item.name;
          _parent = item.parent;
        }
      });
      return [_name, _parent];
    };
    // Build full breadcrumb by traversing ancestors recursively
    const buildBreadcrumb = (mn) => {
      const [name, parent] = getName(mn);
      if (parent) {
        return buildBreadcrumb(parent) + " > " + name;
      }
      return name;
    };
    return buildBreadcrumb(meta_name);
  };
  const getPlValAmount = (meta_name) => {
    if (!meta_name) return "";
    let val = plValues[plValDetailsPl][meta_name];
    return currencyUnit + " " + oom.x + " " + (val / oom.div).toFixed(2);
  };
  const getPlValAmountPerc = (meta_name) => {
    if (!meta_name) return "";
    let activeAnchor;
    if (revenueReference === "combined") {
      const lineIdx = plStructure.current.findIndex(
        (l) => l.meta_name === meta_name,
      );
      const netIdx = plStructure.current.findIndex(
        (l) => l.meta_name === netRevenueAnchor.current,
      );
      activeAnchor =
        lineIdx < netIdx
          ? combinedAboveAnchor?.current
          : netRevenueAnchor.current;
    } else {
      activeAnchor = revenueReference || netRevenueAnchor.current;
    }
    let net_revenue = plValues[plValDetailsPl][activeAnchor];
    if (net_revenue <= 0) return "-";
    let val = plValues[plValDetailsPl][meta_name];
    return ((100 * val) / net_revenue).toFixed(1) + "%";
  };
  const getPlValAmountTotalCompPerc = (meta_name) => {
    if (!meta_name) return "";
    let val = "-";
    if (meta_name) {
      plStructure.current.forEach((line, lineIdx) => {
        if (line.meta_name === meta_name) {
          let refVal;
          if (line.ref_values) {
            if (revenueReference === "combined") {
              const netIdx = plStructure.current.findIndex(
                (l) => l.meta_name === netRevenueAnchor.current,
              );
              const anchor =
                lineIdx < netIdx
                  ? combinedAboveAnchor?.current
                  : netRevenueAnchor.current;
              refVal = anchor ? line.ref_values[anchor] : null;
            } else {
              refVal = line.ref_values[revenueReference] ?? null;
            }
          }
          if (refVal != null) {
            val = (100 * refVal).toFixed(1) + "%";
          }
        }
      });
    }
    return val;
  };
  const getPlValAmountPerVol = (meta_name) => {
    if (!meta_name) return "";
    let vol = plValues[plValDetailsPl].volume;
    if (vol <= 0) return "-";
    let val = plValues[plValDetailsPl][meta_name];
    return (
      formatNumber(val / vol) + " " + currencyUnit + "/" + volumeUnit.current
    );
  };
  const getPlValDetails = (meta_name, numPL) => {
    let params = {
      currency_unit: currencyUnit,
      meta_name,
      common_filters: commonFilters,
      common_filters_mode: commonFiltersMode,
      common_filters_sequence: commonFiltersSequence,
      pl_filters: plFilters[numPL],
      pl_filters_mode: plFiltersMode[numPL],
      pl_filters_sequence: plFiltersSequence[numPL],
    };
    client
      .post("api/results_pl_explorer_read_pl_val_details/", params)
      .then((response) => {
        setPlValDetailsVars(response.data.vars);
        setPlValDetailsPromoters(response.data.promoters);
        setPlValDetailsDetractors(response.data.detractors);
        setDetailsMonthlyEvolution({
          ...detailsMonthlyEvolution,
          data: response.data.evolution,
        });
        setLoadingPlValDetails(false);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
        }
      });
  };
  const getDetailsMonthlyEvolutionData = () => {
    let data = structuredClone(detailsMonthlyEvolution.data);
    data.labels = data.labels.map((month) => t("months." + month));
    data.series = [data.series];
    return data;
  };
  // #endregion

  // #region auto-naming
  const triggerAutoNaming = useCallback(
    (triggerPL = null) => {
      if (triggerPL && isAutoName[triggerPL]) {
        setNamingPlaceholderPL(triggerPL);
      }
      setNamingTrigger((prev) => ({ seq: prev.seq + 1, pl: triggerPL }));
    },
    [isAutoName],
  );

  useEffect(() => {
    if (namingTrigger.seq === 0) return;
    if (!metaLoaded) return;

    const autoNamePLs = Object.keys(isAutoName).filter(
      (k) => isAutoName[k] && plValues[k] !== undefined,
    );
    if (autoNamePLs.length === 0) {
      setNamingPlaceholderPL(null);
      return;
    }
    const hasAnyFilter = autoNamePLs.some(
      (k) => (plFiltersSequence[k]?.length > 0) || plPeriodFilters[k],
    );
    if (autoNamePLs.length === 1 && !hasAnyFilter) {
      setNamingPlaceholderPL(null);
      setPlNames((draft) => {
        autoNamePLs.forEach((k) => { draft[k] = ""; });
      });
      return;
    }

    if (namingDebounceTimer.current) {
      clearTimeout(namingDebounceTimer.current);
    }
    if (namingController.current) {
      namingController.current.abort();
    }

    namingDebounceTimer.current = setTimeout(() => {
      const controller = new AbortController();
      namingController.current = controller;

      const currentNames = {};
      autoNamePLs.forEach((k) => {
        currentNames[k] = plNames[k] || "";
      });

      const plFiltersPayload = {};
      const plFiltersModePayload = {};
      const plFiltersSequencePayload = {};
      const plPeriodPayload = {};
      autoNamePLs.forEach((k) => {
        plFiltersPayload[k] = plFilters[k] || {};
        plFiltersModePayload[k] = plFiltersMode[k] || {};
        plFiltersSequencePayload[k] = plFiltersSequence[k] || [];
        if (plPeriodFilters[k]) {
          plPeriodPayload[k] = plPeriodFilters[k].tuples || [];
        }
      });

      const dimensionNames = {};
      if (filtersNames.current) {
        Object.keys(filtersNames.current).forEach((dim) => {
          dimensionNames[dim] = filtersNames.current[dim];
        });
      }

      client
        .post(
          "api/results_pl_explorer_suggest_names/",
          {
            num_pls: numPLs,
            auto_name_pls: autoNamePLs.map(Number),
            current_names: currentNames,
            common_filters: commonFilters,
            common_filters_mode: commonFiltersMode,
            common_filters_sequence: commonFiltersSequence,
            pl_filters: plFiltersPayload,
            pl_filters_mode: plFiltersModePayload,
            pl_filters_sequence: plFiltersSequencePayload,
            pl_period_filters: plPeriodPayload,
            dimension_names: dimensionNames,
            language: i18n.language,
          },
          { signal: controller.signal },
        )
        .then((response) => {
          const names = response.data?.names || {};
          setPlNames((draft) => {
            Object.entries(names).forEach(([k, v]) => {
              if (isAutoName[k]) {
                draft[k] = v;
              }
            });
          });
          setNamingPlaceholderPL(null);
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            console.error("[AutoNaming] error:", error);
            setNamingPlaceholderPL(null);
          }
        });
    }, 1000);

    return () => {
      if (namingDebounceTimer.current) {
        clearTimeout(namingDebounceTimer.current);
      }
    };
  }, [namingTrigger]); // eslint-disable-line
  // #endregion

  // #region useEffect's
  // ── PLExplorer meta callback (executado depois do hook carregar os filtros) ──
  // Inicializa dados específicos do PL Explorer: estrutura do P&L, cenários, etc.
  useEffect(() => {
    i18n.changeLanguage(i18n.language.slice(0, 2));
    plExplorerMetaCallback.current = (response) => {
      const filters = response.data.filters;
      const initFiltersObj = {};
      const initFiltersStr = {};
      Object.keys(filters.names).forEach((name) => {
        initFiltersObj[name] = [];
        initFiltersStr[name] = "";
      });

      // Init padrão dos filtros por PL (comum já foi iniciado pelo hook)
      setPlFilters((draft) => {
        draft[1] = initFiltersObj;
      });
      setPlFiltersMode((draft) => {
        draft[1] = initFiltersStr;
      });
      setPlFiltersIndexes((draft) => {
        draft[1] = { ...initFiltersObj };
      });

      // P&L specific data
      const pl = response.data.pl;
      volumeUnit.current = pl.volume_unit;
      volumeUnitAlternatives.current = pl.volume_unit_alternatives || [];
      currencyUnitOptions.current = pl.currency_unit_options;
      currencyUnitOptionsAvailable.current =
        pl.currency_unit_options_available;
      plStructure.current = pl.pl_structure;
      netRevenueAnchor.current = pl.net_revenue_anchor;
      serveMarginAnchor.current = pl.serve_margin_anchor;
      revenueAnchors.current = pl.revenue_anchors;
      revenueReferenceOptions.current = pl.revenue_reference_options || [];
      combinedAboveAnchor.current =
        revenueReferenceOptions.current.length > 0
          ? revenueReferenceOptions.current[0].value
          : null;
      if (
        revenueReference === null &&
        revenueReferenceOptions.current.length > 0
      ) {
        const defaultOpt = revenueReferenceOptions.current.find(
          (o) => o.default,
        );
        setRevenueReference(
          defaultOpt ? defaultOpt.value : pl.net_revenue_anchor,
        );
      }
      volumeL12M.current = pl.volume_l12m;
      setDrillDownsOpen(computeInitialDrillDowns(pl.pl_structure, height));

      setCurrencyUnit(pl.default_currency_unit);
      setNumPLs(1);
      setPlValues({ 1: {} });
      setPlsToRefresh([1]);

      scenarioHook.setScenariosFromMeta(response.data.scenarios);
    };
  }, []); // eslint-disable-line
  useEffect(() => {
    [...Array(numPLs)].map((_, i) =>
      refreshPL(
        i + 1,
        commonFilters,
        commonFiltersMode,
        commonFiltersSequence,
        plFilters[i + 1],
        plFiltersMode[i + 1],
        plFiltersSequence[i + 1],
        true,
      ),
    );
    setPlShow([...Array(numPLs).keys()].map((i) => i + 1));
  }, [metaLoaded]);

  // Resolve ?scenario=<hash> from URL after meta is loaded
  useEffect(() => {
    if (metaLoaded) scenarioHook.initFromURL();
  }, [metaLoaded]); // eslint-disable-line

  // Refresh all PLs when hook-driven common filters change (e.g. via ResultsFilterBar)
  useEffect(() => {
    if (!metaLoaded) return;
    if (Object.keys(plValues).length === 0) return;
    setPlsToRefresh(Object.keys(plValues).map((val) => parseInt(val)));
    Object.keys(plValues).forEach((numPL) => {
      refreshPL(parseInt(numPL));
    });
    triggerAutoNaming();
  }, [commonFilters, commonFiltersMode, commonFiltersSequence, rangeFilters]); // eslint-disable-line

  useLayoutEffect(() => {
    // changes the order of magnitude in which all the P&Ls are presented
    //    - fired when the plValues or language is modified
    //    - store results in 'oom' object

    let div, x;

    // If manual OOM is selected, skip expensive calculations
    if (manualOom !== "auto") {
      switch (manualOom) {
        case "units":
          div = 1;
          x = "";
          break;
        case "thousands":
          div = 1e3;
          x = "k";
          break;
        case "millions":
          div = 1e6;
          x = "m";
          break;
        case "billions":
          div = 1e9;
          x = "b";
          break;
        default:
          div = 1e6;
          x = "m";
          break;
      }
      x = x === "" ? x : " " + t("oom." + x);
      setOom({ div: div, x: x });
    } else {
      // Only calculate auto OOM when manualOom is "auto"
      const calculatedOom = calculateOomFromPlValues(plValues, t);
      setOom(calculatedOom);
    }
  }, [plValues, i18n.language, t, manualOom]);
  useEffect(() => {
    if (plsToRefresh.length === 0) {
      scenarioHook.onRefreshComplete();
    }
  }, [plsToRefresh]); // eslint-disable-line
  useEffect(() => {
    if (!metaLoaded) return;
    const hasActiveCommon = commonFiltersSequence.some(
      (f) => f !== "period" && (commonFilters[f] || []).length > 0,
    );
    if (!hasActiveCommon) {
      setAvailableItemsAfterCommon(null);
      setTruncatedDimensions([]);
      return;
    }
    const controller = new AbortController();
    client
      .post(
        "api/results_pl_explorer_update_available_items/",
        {
          currency_unit: currencyUnit,
          common_filters: commonFilters,
          common_filters_mode: commonFiltersMode,
          common_filters_sequence: commonFiltersSequence,
        },
        { signal: controller.signal },
      )
      .then((response) => {
        const data = response.data || {};
        setAvailableItemsAfterCommon(data.items || null);
        setTruncatedDimensions(data.truncated || []);
      })
      .catch((error) => {
        if (!axios.isCancel(error)) console.error(error);
      });
    return () => controller.abort();
  }, [commonFilters, commonFiltersMode, commonFiltersSequence, currencyUnit, metaLoaded]); // eslint-disable-line
  // #endregion

  // #region handlers
  const handleUnitSelection = (opt) => {
    const { option_type, value } = opt;
    if (option_type === "value_type") {
      setShowValueType(value);
    } else if (option_type === "currency") {
      if (value !== currencyUnit) {
        setCurrencyUnit(value);
        setPlsToRefresh(Object.keys(plValues).map((val) => parseInt(val)));
        Object.keys(plValues).map((numPL) => {
          refreshPL(
            numPL,
            commonFilters,
            commonFiltersMode,
            commonFiltersSequence,
            plFilters[numPL],
            plFiltersMode[numPL],
            plFiltersSequence[numPL],
            true,
            value,
          );
        });
      }
    } else if (option_type === "revenue_reference") {
      setRevenueReference(value);
    } else if (option_type === "volume") {
      if (value !== volumeColumn) {
        setVolumeColumn(value);
        const selectedAlt = volumeUnitAlternatives.current.find(
          (o) => o.column === value,
        );
        if (selectedAlt) {
          volumeUnit.current = selectedAlt.label;
        }
        // Re-fetch all PLs with the new volume column
        setPlsToRefresh(Object.keys(plValues).map((val) => parseInt(val)));
        Object.keys(plValues).map((numPL) => {
          refreshPL(
            numPL,
            commonFilters,
            commonFiltersMode,
            commonFiltersSequence,
            plFilters[numPL],
            plFiltersMode[numPL],
            plFiltersSequence[numPL],
            true,
            currencyUnit,
            value,
          );
        });
      }
    } else if (option_type === "oom") {
      setManualOom(value);
    }
  };
  const handleBenchmarkSelection = (opt) => {
    const { value } = opt;
    setBenchmark(value);
  };

  const handleHelpClick = () => {
    setHelpDialogOpen(true);
  };

  const handleComparisonSelection = (filter) => {
    if (filter) {
      // Set loading state immediately
      setComparisonLoading(true);

      // Add all existing P&Ls to refresh list to show waiting mode
      const existingPLs = Object.keys(plValues).map((val) => parseInt(val));
      setPlsToRefresh(existingPLs);

      // Call API to get top items for the selected filter
      client
        .post("api/results_pl_explorer_get_top_items/", {
          meta_name: filter,
          common_filters: commonFilters,
          common_filters_mode: commonFiltersMode,
          common_filters_sequence: commonFiltersSequence,
        })
        .then((response) => {
          const topItems = response.data;

          if (topItems && topItems.length > 0) {
            // Reset all P&Ls
            setNumPLs(0);
            setPlShow([]);
            setPlsToRefresh([]);
            setPlsOnError([]);

            // Clear all existing P&L data
            setPlValues({});
            setPlFilters({});
            setPlFiltersIndexes({});
            setPlFiltersMode({});
            setPlFiltersSequence({});
            setPlNames({});
            setRefreshDelayHandler({});

            // Determine how many P&Ls to create
            const totalItems = topItems.length;
            const numPLsToCreate = Math.min(6, totalItems);

            // Create P&Ls based on the scenario
            const newPlValues = {};
            const newPlFilters = {};
            const newPlFiltersIndexes = {};
            const newPlFiltersMode = {};
            const newPlFiltersSequence = {};
            const newPlNames = {};
            const newRefreshDelayHandler = {};

            for (let i = 1; i <= numPLsToCreate; i++) {
              let itemsForThisPL = [];
              let plName = "";

              if (i <= 5) {
                // First 5 P&Ls: each gets one item
                itemsForThisPL = [topItems[i - 1]];
                // Handle empty string items
                if (topItems[i - 1] === "") {
                  plName = "● " + t("results.blank") + " ●";
                } else {
                  plName = topItems[i - 1].substring(0, 20); // Limit to 20 characters
                }
              } else if (i === 6) {
                // 6th P&L: gets all remaining items (up to 100)
                const remainingItems = topItems.slice(5, 105); // Get items 6-105 (up to 100 items)
                itemsForThisPL = remainingItems;
                const otherCount = remainingItems.length;
                // Use a more specific translation key to avoid conflicts
                if (otherCount > 1) {
                  const othersText =
                    i18n.language === "es"
                      ? "Otros(as)"
                      : i18n.language === "pt"
                        ? "Outros(as)"
                        : "Others";
                  plName = `${othersText} ${otherCount}`.substring(0, 20); // Limit to 20 characters
                } else {
                  plName = topItems[i - 1].substring(0, 20); // Limit to 20 characters
                }
              }

              // Set up filter for this P&L
              newPlFilters[i] = {
                [filter]: itemsForThisPL,
              };

              // Set up filter indexes
              const filterIndexes = getIndexes(
                filtersItems.current[filter],
                itemsForThisPL,
              );
              newPlFiltersIndexes[i] = {
                [filter]: filterIndexes,
              };

              // Set up filter mode
              newPlFiltersMode[i] = {
                [filter]: "items",
              };

              // Set up filter sequence
              newPlFiltersSequence[i] = [filter];

              // Set up P&L name
              newPlNames[i] = plName;

              // Set up refresh handler
              newRefreshDelayHandler[i] = {
                delay_handler: null,
                controller: new AbortController(),
              };

              // Initialize empty P&L values
              newPlValues[i] = {};
            }

            // Update all state
            setPlValues(newPlValues);
            setPlFilters(newPlFilters);
            setPlFiltersIndexes(newPlFiltersIndexes);
            setPlFiltersMode(newPlFiltersMode);
            setPlFiltersSequence(newPlFiltersSequence);
            setPlNames(newPlNames);
            setRefreshDelayHandler(newRefreshDelayHandler);

            const newIsAutoName = {};
            for (let i = 1; i <= numPLsToCreate; i++) {
              newIsAutoName[i] = true;
            }
            setIsAutoName(newIsAutoName);

            // Set number of P&Ls and show them
            setNumPLs(numPLsToCreate);
            setPlShow([...Array(numPLsToCreate).keys()].map((i) => i + 1));

            // Mark all P&Ls for refresh
            setPlsToRefresh([...Array(numPLsToCreate)].map((_, i) => i + 1));

            // Use setTimeout to ensure state is properly set before calling refreshPL
            setTimeout(() => {
              for (let i = 1; i <= numPLsToCreate; i++) {
                refreshPL(
                  i,
                  commonFilters,
                  commonFiltersMode,
                  commonFiltersSequence,
                  newPlFilters[i],
                  newPlFiltersMode[i],
                  newPlFiltersSequence[i],
                );
              }
            }, 0);
          } else {
            notify(
              "results.comparison_dropdown.no_data_for_filters",
              "warning",
            );
            setPlsToRefresh([]);
          }

          // Clear loading state
          setComparisonLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching top items:", error);
          notify("results.comparison_dropdown.error_fetching_items", "error");

          setComparisonLoading(false);
          setPlsToRefresh([]);
        });
    }
  };
  // ── PL-scope DimFilterDialog handlers ────────────────────────────────────
  const plDimDialogDim = useMemo(() => {
    if (!plFilterModalCurrentFilter) return null;
    return getDimInfo(plFilterModalCurrentFilter);
  }, [plFilterModalCurrentFilter, getDimInfo]);

  const plDimExistingFilter = useMemo(() => {
    if (!plFilterModalCurrentFilter || !plFilterModalCurrentPl) return null;
    const numPL = plFilterModalCurrentPl;
    const filter = plFilterModalCurrentFilter;
    const mode = plFiltersMode?.[numPL]?.[filter];
    const values = plFilters?.[numPL]?.[filter] || [];
    if (mode === "items" && values.length > 0) {
      return { mode: "items", items: values, multiSelect: values.length > 1 };
    }
    if (mode === "group" && values.length > 0) {
      return { mode: "group", groupKey: values[0] };
    }
    const rf = plRangeFilters?.[numPL]?.[filter];
    if (rf) {
      return {
        mode: "range",
        rangeMode: rf.mode,
        rangeMin: rf.min != null ? String(rf.min) : "",
        rangeMax: rf.max != null ? String(rf.max) : "",
        refLine: rf.refLine || "",
        items: [rf.label || ""],
      };
    }
    return null;
  }, [plFilters, plFiltersMode, plRangeFilters, plFilterModalCurrentFilter, plFilterModalCurrentPl]);

  const handlePlDimApply = useCallback(
    (filterObj) => {
      const { mode, items, indexes, groupKey } = filterObj;
      const numPL = plFilterModalCurrentPl;
      const filter = plFilterModalCurrentFilter;
      if (!numPL || !filter) return;

      if (mode === "items") {
        setPlFiltersIndexes((draft) => {
          draft[numPL][filter] = indexes || [];
        });
        const itemValues =
          items ||
          (indexes || []).map((i) => filtersItems.current[filter][i]);
        const pl_filters = { ...plFilters[numPL], [filter]: itemValues };
        setPlFilters((draft) => {
          draft[numPL][filter] = itemValues;
        });
        const pl_filters_mode = {
          ...plFiltersMode[numPL],
          [filter]: "items",
        };
        setPlFiltersMode((draft) => {
          draft[numPL][filter] = "items";
        });
        const pl_filters_sequence = structuredClone(plFiltersSequence[numPL]);
        if (!pl_filters_sequence.includes(filter)) {
          pl_filters_sequence.push(filter);
          setPlFiltersSequence((draft) => {
            draft[numPL] = pl_filters_sequence;
          });
        }
        setPlsToRefresh(
          plsToRefresh.includes(numPL)
            ? plsToRefresh
            : [...plsToRefresh, numPL],
        );
        refreshPL(
          numPL,
          commonFilters,
          commonFiltersMode,
          commonFiltersSequence,
          pl_filters,
          pl_filters_mode,
          pl_filters_sequence,
        );
      } else if (mode === "group") {
        setPlFiltersIndexes((draft) => {
          draft[numPL][filter] = [];
        });
        const pl_filters = { ...plFilters[numPL], [filter]: [groupKey] };
        setPlFilters((draft) => {
          draft[numPL][filter] = [groupKey];
        });
        const pl_filters_mode = {
          ...plFiltersMode[numPL],
          [filter]: "group",
        };
        setPlFiltersMode((draft) => {
          draft[numPL][filter] = "group";
        });
        const pl_filters_sequence = structuredClone(plFiltersSequence[numPL]);
        if (!pl_filters_sequence.includes(filter)) {
          pl_filters_sequence.push(filter);
          setPlFiltersSequence((draft) => {
            draft[numPL] = pl_filters_sequence;
          });
        }
        setPlsToRefresh(
          plsToRefresh.includes(numPL)
            ? plsToRefresh
            : [...plsToRefresh, numPL],
        );
        refreshPL(
          numPL,
          commonFilters,
          commonFiltersMode,
          commonFiltersSequence,
          pl_filters,
          pl_filters_mode,
          pl_filters_sequence,
        );
      } else if (mode === "range") {
        // Remove conflitos de items/group para esta dimensão
        if (plFiltersMode[numPL]?.[filter]) {
          setPlFilters((d) => {
            d[numPL][filter] = [];
          });
          setPlFiltersMode((d) => {
            d[numPL][filter] = "";
          });
          setPlFiltersSequence((d) => {
            d[numPL] = (d[numPL] || []).filter((f) => f !== filter);
          });
        }
        // Computa novo range filter para este P&L
        const newRangeEntry = {
          mode: filterObj.rangeMode,
          min:
            filterObj.rangeMin !== "" && filterObj.rangeMin != null
              ? parseFloat(filterObj.rangeMin)
              : null,
          max:
            filterObj.rangeMax !== "" && filterObj.rangeMax != null
              ? parseFloat(filterObj.rangeMax)
              : null,
          refLine: filterObj.refLine || null,
          label: filterObj.items?.[0] || "",
        };
        setPlRangeFilters((draft) => {
          if (!draft[numPL]) draft[numPL] = {};
          draft[numPL][filter] = newRangeEntry;
        });
        // Mescla com os range filters globais e chama refreshPL explicitamente
        const mergedGlobal = Object.entries(rangeFilters).map(([dim, f]) => ({
          dimension: dim,
          mode: f.mode,
          min: f.min,
          max: f.max,
          ref_line: f.refLine,
        }));
        const mergedPl = Object.entries({
          ...(plRangeFilters[numPL] || {}),
          [filter]: newRangeEntry,
        }).map(([dim, f]) => ({
          dimension: dim,
          mode: f.mode,
          min: f.min,
          max: f.max,
          ref_line: f.refLine,
        }));
        const allRange = [...mergedGlobal, ...mergedPl];
        setPlsToRefresh(
          plsToRefresh.includes(numPL) ? plsToRefresh : [...plsToRefresh, numPL],
        );
        refreshPL(
          numPL,
          commonFilters,
          commonFiltersMode,
          commonFiltersSequence,
          plFilters[numPL],
          plFiltersMode[numPL],
          plFiltersSequence[numPL],
          false,
          currencyUnit,
          volumeColumn,
          allRange,
        );
      }
      setPlFilterModalOpen(false);
      triggerAutoNaming(numPL);
    },
    [
      plFilterModalCurrentPl,
      plFilterModalCurrentFilter,
      plFilters,
      plFiltersMode,
      plFiltersSequence,
      plRangeFilters,
      commonFilters,
      commonFiltersMode,
      commonFiltersSequence,
      plsToRefresh,
      triggerAutoNaming,
    ],
  );

  const handlePlDimClear = useCallback(() => {
    const numPL = plFilterModalCurrentPl;
    const filter = plFilterModalCurrentFilter;
    if (!numPL || !filter) return;
    setPlFiltersIndexes((draft) => {
      draft[numPL][filter] = [];
    });
    const pl_filters = { ...plFilters[numPL], [filter]: [] };
    setPlFilters((draft) => {
      draft[numPL][filter] = [];
    });
    const pl_filters_mode = { ...plFiltersMode[numPL], [filter]: "" };
    setPlFiltersMode((draft) => {
      draft[numPL][filter] = "";
    });
    const pl_filters_sequence = plFiltersSequence[numPL].filter(
      (f) => f !== filter,
    );
    setPlFiltersSequence((draft) => {
      draft[numPL] = pl_filters_sequence;
    });
    // Limpa range filter específico deste P&L para a dimensão
    setPlRangeFilters((draft) => {
      if (draft[numPL]) delete draft[numPL][filter];
    });
    setPlsToRefresh(
      plsToRefresh.includes(numPL) ? plsToRefresh : [...plsToRefresh, numPL],
    );
    refreshPL(
      numPL,
      commonFilters,
      commonFiltersMode,
      commonFiltersSequence,
      pl_filters,
      pl_filters_mode,
      pl_filters_sequence,
    );
    setPlFilterModalOpen(false);
    triggerAutoNaming(numPL);
  }, [
    plFilterModalCurrentPl,
    plFilterModalCurrentFilter,
    plFilters,
    plFiltersMode,
    plFiltersSequence,
    plRangeFilters,
    commonFilters,
    commonFiltersMode,
    commonFiltersSequence,
    plsToRefresh,
    triggerAutoNaming,
  ]);
  // ── Per-PL period filter handlers ──────────────────────────────────────────
  const handlePlPeriodOpen = useCallback((numPL) => {
    setPlPeriodModalPl(numPL);
    setPlPeriodModalOpen(true);
  }, []);

  const handlePlPeriodApply = useCallback(
    ({ selectedKeys }) => {
      const numPL = plPeriodModalPl;
      if (!numPL) return;
      let tuples = null;
      if (!selectedKeys || selectedKeys.size === 0) {
        setPlPeriodFilters((d) => { delete d[numPL]; });
      } else {
        tuples = [...selectedKeys]
          .map((k) => k.split("-").map(Number))
          .sort((a, b) => a[0] * 12 + a[1] - (b[0] * 12 + b[1]));
        setPlPeriodFilters((d) => {
          d[numPL] = { tuples, keys: selectedKeys };
        });
      }
      setPlPeriodModalOpen(false);
      setPlsToRefresh((prev) =>
        prev.includes(numPL) ? prev : [...prev, numPL],
      );
      refreshPL(
        numPL,
        undefined, undefined, undefined,
        undefined, undefined, undefined,
        false, undefined, undefined, null,
        tuples,
      );
      triggerAutoNaming(numPL);
    },
    [plPeriodModalPl, triggerAutoNaming], // eslint-disable-line
  );

  const handlePlPeriodClear = useCallback(
    (numPL) => {
      setPlPeriodFilters((d) => { delete d[numPL]; });
      setPlsToRefresh((prev) =>
        prev.includes(numPL) ? prev : [...prev, numPL],
      );
      refreshPL(
        numPL,
        undefined, undefined, undefined,
        undefined, undefined, undefined,
        false, undefined, undefined, null,
        null,
      );
      triggerAutoNaming(numPL);
    },
    [triggerAutoNaming], // eslint-disable-line
  );

  const handleMouseOverPLLine = useCallback((meta_name) => {
    setMouseOverPLLine(meta_name);
    setMouseOverPLLineFade(meta_name);
  }, []);
  const handleMouseLeavePLLine = useCallback(() => {
    setMouseOverPLLine(null);
    setMouseOverPLLineFade(null);
  }, []);
  const handleOpenAnalysisDrawer = useCallback(
    (meta_name, numPL) => {
      if (revenueAnchors.current.includes(meta_name)) return false;
      if (plsToRefresh.length > 0) return false;

      setLoadingPlValDetails(true);
      setPlValDetailsPl(numPL);
      setPlValDetailsName(meta_name);
      setPlValDetailsVars([]);
      setPlValDetailsPromoters({});
      setPlValDetailsDetractors({});
      setDetailsMonthlyEvolution({
        ...linePercentageChart,
        data: {
          labels: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
          ],
          series: [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
        },
      });
      getPlValDetails(meta_name, numPL);
    },
    [plsToRefresh, getPlValDetails],
  );
  const handleChangePLNameClick = useCallback(
    (numPL) => {
      setPLNameModalCurrentNum(numPL);
      setPlNameModalInput(plNames[numPL]);
      setPlNameModalOpen(true);
      if (plNameInput.current)
        setTimeout(() => plNameInput.current.firstChild.focus(), 100);
    },
    [plNames],
  );
  const handlePLNameChange = (event) => {
    setPlNameModalInput(event.target.value);
  };
  const handlePLNameChangeApply = () => {
    let name = stripText(plNameModalInput);
    setPlNames((draft) => {
      draft[plNameModalCurrentNum] = name;
    });
    setIsAutoName((draft) => {
      draft[plNameModalCurrentNum] = name === "";
    });
    setPlNameModalOpen(false);
    if (name === "") {
      triggerAutoNaming(plNameModalCurrentNum);
    }
  };
  // #endregion

  // #region components
  const getPLMdWidth = (numPL) => {
    if (numPL === 1) {
      if (numPLs <= 4) {
        return 4;
      } else {
        return 3;
      }
    } else {
      if (numPLs > 3) {
        return true;
      } else {
        return 4;
      }
    }
  };
  const getPL = (numPL) => {
    numPL += 1;
    if (plValues[numPL]) {
      return (
        <GridItem
          sm={12}
          md={getPLMdWidth(numPL)}
          key={numPL}
          onClick={() => clearTimeouts()}
          onContextMenu={() => clearTimeouts()}
          zeroMinWidth
          className={cx({
            [classes.plDisplay]: true,
            show: plShow.includes(numPL),
          })}
        >
          <GridContainer>
            <GridItem xs={12} className={classes.plCardWrapper}>
              <Card
                className={classes.plCard}
                onMouseEnter={() => allowTimers()}
                onMouseLeave={() => disallowTimers()}
              >
                <CardBody className={classes.plCardBody}>
                  <Pnl
                    plStructure={plStructure}
                    netRevenueAnchor={netRevenueAnchor}
                    combinedAboveAnchor={combinedAboveAnchor}
                    revenueReference={revenueReference}
                    serveMarginAnchor={serveMarginAnchor}
                    revenueAnchors={revenueAnchors.current}
                    numPL={numPL}
                    numPLs={numPLs}
                    maxPLs={maxPLs}
                    plNames={plNames}
                    plName={plNames[numPL]}
                    filterable={true}
                    handleChangePLNameClick={handleChangePLNameClick}
                    handleMouseLeavePLLine={handleMouseLeavePLLine}
                    handleMouseOverPLLine={handleMouseOverPLLine}
                    mouseOverPLLine={mouseOverPLLine}
                    mouseOverPLLineFade={mouseOverPLLineFade}
                    handleOpenAnalysisDrawer={handleOpenAnalysisDrawer}
                    showAnalysisOption={true}
                    drillDownsOpen={drillDownsOpen}
                    setDrillDownsOpen={setDrillDownsOpen}
                    timersAllowed={timersAllowed.current}
                    filtersListTranslated={filtersListTranslated}
                    filtersActiveList={filtersActiveListPL}
                    filtersSequence={filtersSequence}
                    filterScopeData={getFilterScopeData()}
                    filterMenuClickHandler={filterMenuClickHandler}
                    filterDropdownProps={{
                      filtersList: ["period", ...(filtersList.current || []).filter((f) => f !== "period")],
                      filtersNames: {
                        ...filtersNames.current,
                        period: { pt: "Período", en: "Period", es: "Período" },
                      },
                      plFilters: {
                        ...(plFilters[numPL] || {}),
                        ...(plPeriodFilters[numPL]
                          ? { period: plPeriodFilters[numPL].tuples }
                          : {}),
                      },
                      plFiltersSequence: [
                        ...(plPeriodFilters[numPL] ? ["period"] : []),
                        ...(plFiltersSequence[numPL] || []),
                        ...Object.keys(plRangeFilters[numPL] || {}).filter(
                          (k) => !(plFiltersSequence[numPL] || []).includes(k),
                        ),
                      ],
                      sections: dimSections,
                      language: i18n.language,
                      color: clientColor,
                      onPeriodSelect: () => handlePlPeriodOpen(numPL),
                    }}
                    addPL={addPL}
                    removePL={removePL}
                    plsOnError={plsOnError}
                    retryPL={retryPL}
                    plsToRefresh={plsToRefresh}
                    isRefreshing={false}
                    plValues={plValues}
                    volumeUnit={volumeUnit}
                    volumeL12M={volumeL12M}
                    currencyUnit={currencyUnit}
                    showValueType={showValueType}
                    isLoading={!metaLoaded}
                    showColumns={
                      useThreeColumns
                        ? ["name", "val", "val_volume", "percentage"]
                        : undefined
                    }
                    benchmark={benchmark}
                    oom={oom}
                    onOpenAIChat={
                      canUseAIChat(userDetails)
                        ? openChatWithPLFilters
                        : undefined
                    }
                    namingPlaceholder={namingPlaceholderPL === numPL}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      );
    } else {
      return null;
    }
  };
  const PLs = [...Array(numPLs)].map((_, key) => getPL(key));
  const plAppliedFilters = (numPL, context) => {
    return !Object.keys(plValues).includes(numPL.toString()) ? null : (
      <>
        <div className={classes.plAppliedFiltersWrapper}>
          <div className={classes.plAppliedFiltersHeader + " " + context}>
            {t("results.filters_applied_to_pl")}
          </div>
          <GridItem xs={12}>
            {getFiltersNamesInSequence(numPL).map((filter, key) => (
              <FilterTag
                key={key}
                filtersList={filtersList.current}
                filtersNames={filtersNames.current}
                filtersGroups={filtersGroups.current}
                filter={filter}
                items={getFilterItems(
                  plFilters[numPL][filter],
                  filter,
                  plFiltersMode[numPL][filter],
                )}
                indexes={plFiltersIndexes[numPL][filter]}
                mode={plFiltersMode[numPL][filter]}
                removeItemHandler={removeCommonFilter}
                color={"light"}
                viewOnly
              />
            ))}
          </GridItem>
        </div>
      </>
    );
  };
  const plFilterDialog = (
    <DimFilterDialog
      open={plFilterModalOpen}
      dim={plDimDialogDim}
      existingFilter={plDimExistingFilter}
      onApply={handlePlDimApply}
      onClear={handlePlDimClear}
      onClose={() => setPlFilterModalOpen(false)}
      clientColor={clientColor}
      availableItems={
        plFilterModalCurrentFilter &&
        !truncatedDimensions.includes(plFilterModalCurrentFilter)
          ? availableItemsAfterCommon?.[plFilterModalCurrentFilter] ?? null
          : null
      }
    />
  );
  const plNameDialog = (
    <>
      <Dialog
        classes={{
          root: classes.modalRoot,
          paper: classes.modal,
        }}
        open={plNameModalOpen}
        keepMounted
        onClose={() => setPlNameModalOpen(false)}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
        fullWidth
        maxWidth={"sm"}
      >
        <ModalHeader
          id="content-modal-slide-title"
          title={t("results.alias_modal.alias_to_pl")}
          subtitle={`P&L ${plNameModalCurrentNum}`}
          onClose={() => setPlNameModalOpen(false)}
          closeLabel={t("common.close")}
          clientColor={clientColor}
        />
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
          style={{ paddingTop: "0" }}
        >
          <GridContainer alignItems={"center"}>
            <GridItem xs={12}>
              <CustomInput
                labelText={t("results.alias_modal.set_a_name_for_the_pl")}
                id="pl_name"
                value={plNameModalInput}
                onChange={handlePLNameChange}
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  type: "text",
                  autoComplete: "off",
                  maxLength: "40",
                }}
                client
                helperText={
                  plNameModalInput.length + "/40 " + t("results.characters")
                }
                ref={plNameInput}
                onEnterKey={() => handlePLNameChangeApply()}
              />
            </GridItem>
            {plAppliedFilters(plNameModalCurrentNum, "modal")}
          </GridContainer>
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <GridContainer>
            <GridItem xs={true}></GridItem>
            <GridItem>
              <Button
                onClick={() => handlePLNameChangeApply()}
                color="info"
                simple
              >
                {t("results.filter_modal.apply")}
              </Button>
              <Button
                onClick={() => setPlNameModalOpen(false)}
                color="danger"
                simple
              >
                {t("results.filter_modal.close")}
              </Button>
            </GridItem>
          </GridContainer>
        </DialogActions>
      </Dialog>
    </>
  );
  const detailsDrawer = (
    <>
      <Drawer
        anchor={"right"}
        open={plValDetailsName !== null}
        onClose={() => setPlValDetailsName(null)}
        BackdropProps={{ style: { backgroundColor: "#000", opacity: "0.1" } }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
          },
        }}
      >
        <div className={classes.drawerSpinner}>
          <ThreeDots
            visible={loadingPlValDetails}
            color={clientColor}
            ariaLabel="loading"
            height={"20px"}
            wrapperStyle={{}}
            wrapperClass=""
          />
        </div>
        <ModalHeader
          id="content-modal-slide-title"
          title={
            "P&L " +
            plValDetailsPl +
            (plNames[plValDetailsPl] ? " - " + plNames[plValDetailsPl] : "")
          }
          subtitleParts={[
            <strong>{getPlValName(plValDetailsName)}</strong>,
            getPlValAmount(plValDetailsName),
            `${getPlValAmountPerc(plValDetailsName)} ${t(
              "results.details_modal.of_the_revenue",
            )}`,
          ]}
          pills={[
            {
              key: "total-company",
              label: `vs ${getPlValAmountTotalCompPerc(plValDetailsName)} ${t(
                "results.details_modal.total_company_12m",
              )}`,
            },
          ]}
          onClose={() => setPlValDetailsName(null)}
          closeLabel={t("common.close")}
          clientColor={clientColor}
          variant="drawer"
        />
        <div className={classes.drawerContentWrapper}>
          <div className={classes.drawerPlAppliedFiltersWrapper}>
            {plAppliedFilters(plValDetailsPl, "drawer")}
          </div>
          <h6 className={classes.drawerSectionTitle}>
            {t("results.details_modal.main_promoters")}
            <span
              className={cx({
                [classes.drawerSectionTitleIcon]: true,
                ["positiveTrend"]: true,
              })}
            >
              <FontAwesomeIcon icon="arrow-trend-up" />
            </span>
            <HelpTooltip
              tooltip={t("results.details_modal.promoter_detractor_tooltip")}
            />
          </h6>
          <div className={classes.drawerTable}>
            <div>
              <GridContainer
                className={cx({
                  [classes.drawerTableContent]: true,
                  [classes.drawerTableHeader]: true,
                })}
              >
                <GridItem>{"#"}</GridItem>
                <GridItem>
                  {plValDetailsVars.length > 0
                    ? plValDetailsVars[0][i18n.language]
                    : "-"}
                </GridItem>
                <GridItem>
                  {plValDetailsVars.length > 1
                    ? plValDetailsVars[1][i18n.language]
                    : "-"}
                </GridItem>
                <GridItem>
                  {plValDetailsVars.length > 2
                    ? plValDetailsVars[2][i18n.language]
                    : "-"}
                </GridItem>
              </GridContainer>
            </div>
            {[0, 1, 2, 3, 4].map((val) => (
              <div key={val}>
                <GridContainer
                  className={cx({
                    [classes.drawerTableContent]: true,
                    [classes.drawerTableData]: true,
                  })}
                >
                  <GridItem>{val + 1}</GridItem>
                  <GridItem>
                    {plValDetailsPromoters["vals1"] &&
                      plValDetailsPromoters["vals1"].length > val && (
                        <>
                          {(plValDetailsPromoters["vals1"][val].item
                            ? plValDetailsPromoters["vals1"][val].item.slice(
                                0,
                                15,
                              )
                            : "● " + t("results.blank") + " ●") + " ("}
                          <span
                            className={cx({
                              [classes.positive]: true,
                            })}
                          >
                            {plValDetailsPromoters["vals1"][val].impact > 0
                              ? "+"
                              : ""}
                            {(
                              100 * plValDetailsPromoters["vals1"][val].impact
                            ).toFixed(2) + " pp"}
                          </span>
                          {")"}
                        </>
                      )}
                  </GridItem>
                  <GridItem>
                    {plValDetailsPromoters["vals2"] &&
                      plValDetailsPromoters["vals2"].length > val && (
                        <>
                          {(plValDetailsPromoters["vals2"][val].item
                            ? plValDetailsPromoters["vals2"][val].item.slice(
                                0,
                                15,
                              )
                            : "● " + t("results.blank") + " ●") + " ("}
                          <span
                            className={cx({
                              [classes.positive]: true,
                            })}
                          >
                            {plValDetailsPromoters["vals2"][val].impact > 0
                              ? "+"
                              : ""}
                            {(
                              100 * plValDetailsPromoters["vals2"][val].impact
                            ).toFixed(2) + " pp"}
                          </span>
                          {")"}
                        </>
                      )}
                  </GridItem>
                  <GridItem>
                    {plValDetailsPromoters["vals3"] &&
                      plValDetailsPromoters["vals3"].length > val && (
                        <>
                          {(plValDetailsPromoters["vals3"][val].item
                            ? plValDetailsPromoters["vals3"][val].item.slice(
                                0,
                                15,
                              )
                            : "● " + t("results.blank") + " ●") + " ("}
                          <span
                            className={cx({
                              [classes.positive]: true,
                            })}
                          >
                            {plValDetailsPromoters["vals3"][val].impact > 0
                              ? "+"
                              : ""}
                            {(
                              100 * plValDetailsPromoters["vals3"][val].impact
                            ).toFixed(2) + " pp"}
                          </span>
                          {")"}
                        </>
                      )}
                  </GridItem>
                </GridContainer>
              </div>
            ))}
          </div>
          <h6 className={classes.drawerSectionTitle}>
            {t("results.details_modal.main_detractors")}
            <span
              className={cx({
                [classes.drawerSectionTitleIcon]: true,
                ["negativeTrend"]: true,
              })}
            >
              <FontAwesomeIcon icon="arrow-trend-down" />
            </span>
            <HelpTooltip
              tooltip={t("results.details_modal.promoter_detractor_tooltip")}
            />
          </h6>
          <div className={classes.drawerTable}>
            <div>
              <GridContainer
                className={cx({
                  [classes.drawerTableContent]: true,
                  [classes.drawerTableHeader]: true,
                })}
              >
                <GridItem>{"#"}</GridItem>
                <GridItem>
                  {plValDetailsVars.length > 0
                    ? plValDetailsVars[0][i18n.language]
                    : "-"}
                </GridItem>
                <GridItem>
                  {plValDetailsVars.length > 1
                    ? plValDetailsVars[1][i18n.language]
                    : "-"}
                </GridItem>
                <GridItem>
                  {plValDetailsVars.length > 2
                    ? plValDetailsVars[2][i18n.language]
                    : "-"}
                </GridItem>
              </GridContainer>
            </div>
            {[0, 1, 2, 3, 4].map((val) => (
              <div key={val}>
                <GridContainer
                  className={cx({
                    [classes.drawerTableContent]: true,
                    [classes.drawerTableData]: true,
                  })}
                >
                  <GridItem>{val + 1}</GridItem>
                  <GridItem>
                    {plValDetailsDetractors["vals1"] &&
                      plValDetailsDetractors["vals1"].length > val && (
                        <>
                          {(plValDetailsDetractors["vals1"][val].item
                            ? plValDetailsDetractors["vals1"][val].item.slice(
                                0,
                                15,
                              )
                            : "● " + t("results.blank") + " ●") + " ("}
                          <span
                            className={cx({
                              [classes.negative]: true,
                            })}
                          >
                            {(
                              100 * plValDetailsDetractors["vals1"][val].impact
                            ).toFixed(2) + " pp"}
                          </span>
                          {")"}
                        </>
                      )}
                  </GridItem>
                  <GridItem>
                    {plValDetailsDetractors["vals2"] &&
                      plValDetailsDetractors["vals2"].length > val && (
                        <>
                          {(plValDetailsDetractors["vals2"][val].item
                            ? plValDetailsDetractors["vals2"][val].item.slice(
                                0,
                                15,
                              )
                            : "● " + t("results.blank") + " ●") + " ("}
                          <span
                            className={cx({
                              [classes.negative]: true,
                            })}
                          >
                            {(
                              100 * plValDetailsDetractors["vals2"][val].impact
                            ).toFixed(2) + " pp"}
                          </span>
                          {")"}
                        </>
                      )}
                  </GridItem>
                  <GridItem>
                    {plValDetailsDetractors["vals3"] &&
                      plValDetailsDetractors["vals3"].length > val && (
                        <>
                          {(plValDetailsDetractors["vals3"][val].item
                            ? plValDetailsDetractors["vals3"][val].item.slice(
                                0,
                                15,
                              )
                            : "● " + t("results.blank") + " ●") + " ("}
                          <span
                            className={cx({
                              [classes.negative]: true,
                            })}
                          >
                            {(
                              100 * plValDetailsDetractors["vals3"][val].impact
                            ).toFixed(2) + " pp"}
                          </span>
                          {")"}
                        </>
                      )}
                  </GridItem>
                </GridContainer>
              </div>
            ))}
          </div>
          <h6 className={classes.drawerSectionTitle}>
            {t("results.details_modal.12m_evolution")}
          </h6>
          <div className={classes.drawerGraphWrapper}>
            <div className={classes.drawerGraph}>
              <ChartistGraph
                className="ct-chart-white-colors"
                data={getDetailsMonthlyEvolutionData()}
                type="Line"
                options={detailsMonthlyEvolution.options}
                listener={detailsMonthlyEvolution.animation}
              />
            </div>
          </div>
        </div>
        <div className={classes.drawerFootnote}>
          <ul>
            <li>{t("results.details_modal.footnote1")}</li>
            <li>{t("results.details_modal.footnote2")}</li>
          </ul>
        </div>
      </Drawer>
    </>
  );
  const plActions = (
    <>
      {/* Add P&L */}
      <ActionBarButton
        icon={<AddCircle />}
        text={t("results.add_pl")}
        onClickHandler={() => addPL(0)}
        disabled={!metaLoaded || numPLs === maxPLs || plsToRefresh.length > 0}
      />
      {/* Scenarios */}
      <ScenarioControls
        scenarioHook={scenarioHook}
        disabled={!metaLoaded || plsToRefresh.length > 0}
        classes={classes}
        notifyCopy={notifyCopy}
      />
      {/* Comparison */}
      <DimDropdown
        filtersList={(filtersList.current || []).filter(
          (f) => f !== "period",
        )}
        filtersNames={filtersNames.current || {}}
        sections={dimSections}
        language={i18n.language}
        color={clientColor}
        onSelect={handleComparisonSelection}
        showActiveIndicators={false}
        customTrigger={
          <ActionBarButton
            icon={<FontAwesomeIcon icon={faScaleBalanced} />}
            text={t("results.comparison")}
            disabled={!metaLoaded || comparisonLoading}
          />
        }
      />
      {/* Unit */}
      <ActionDropdown
        button={
          <ActionBarButton
            icon={<AttachMoney />}
            text={t("results.unit")}
            disabled={!metaLoaded}
          />
        }
        dropdownList={getUnitOptions()}
        onClick={handleUnitSelection}
      />
      {/* Benchmarks */}
      <ActionDropdown
        button={
          <ActionBarButton
            icon={<Traffic />}
            text={t("results.benchmark")}
            disabled={!metaLoaded}
          />
        }
        dropdownList={benchmarkOptions}
        onClick={handleBenchmarkSelection}
      />
      {/* Take photo */}
      <ActionBarButton
        icon={<PhotoCamera />}
        text={t("results.take_photo")}
        onClickHandler={downloadScreenshot}
        disabled={!metaLoaded}
      />
      {/* Help */}
      <ActionBarButton
        icon={<HelpOutline />}
        text={t("results.help")}
        onClickHandler={handleHelpClick}
        disabled={!metaLoaded}
      />
    </>
  );
  // #endregion

  return (
    <>
      <div>
        <Hidden smDown>
          <ActionBar
            actions={plActions}
            spinnerIn={
              !metaLoaded ||
              plsToRefresh.length > 0 ||
              scenarioHook.busy ||
              comparisonLoading
            }
          />
        </Hidden>
        <div ref={resultsRef}>
          <GridContainer style={{ marginTop: "-28px" }}>
            <Hidden mdUp>
              <GridItem xs={12} onMouseEnter={() => clearTimeouts()}>
                <ActionBar
                  actions={plActions}
                  spinnerIn={
                    !metaLoaded ||
                    plsToRefresh.length > 0 ||
                    scenarioHook.busy ||
                    comparisonLoading
                  }
                  sm
                />
              </GridItem>
            </Hidden>
            <GridItem xs={12} style={{ padding: 0 }}>
              <ResultsFilterBar
                barLabel={t("results.filter_bar.common_label")}
                filtersList={filtersList}
                filtersNames={filtersNames}
                filtersGroups={filtersGroups}
                commonFilters={commonFilters}
                commonFiltersMode={commonFiltersMode}
                commonFiltersSequence={commonFiltersSequence}
                filterMenuClickHandler={hookFilterMenuClickHandler}
                removeFilter={removeFilter}
                dimFilterDialogProps={dimFilterDialogProps}
                clientColor={clientColor}
                sections={dimSections}
                showPeriodExtras={true}
                periodExtrasProps={{
                  availablePeriods,
                  selectedPeriodKeys,
                  activePreset,
                  onPeriodApply: handlePeriodApply,
                  persist,
                  onPersistChange: setPersist,
                  onReset: handleResetFilters,
                }}
                rangeFilters={rangeFilters}
                clearRangeFilter={clearRangeFilter}
              />
            </GridItem>
            <GridItem xs={12}>
              <PnlSharedProvider
                plValues={plValues}
                plStructure={plStructure}
                benchmark={benchmark}
                netRevenueAnchor={netRevenueAnchor}
                combinedAboveAnchor={combinedAboveAnchor}
                revenueReference={revenueReference}
                serveMarginAnchor={serveMarginAnchor}
                oom={oom}
                t={t}
              >
                <GridContainer className={classes.plWrapperOuter}>
                  {PLs}
                </GridContainer>
              </PnlSharedProvider>
            </GridItem>
          </GridContainer>
        </div>
        {plFilterDialog}
        <PeriodFilterModal
          open={plPeriodModalOpen}
          onClose={() => setPlPeriodModalOpen(false)}
          onApply={(result) => {
            handlePlPeriodApply(result);
          }}
          onClear={() => {
            if (plPeriodModalPl) handlePlPeriodClear(plPeriodModalPl);
          }}
          availablePeriods={availablePeriods}
          initialSelectedKeys={
            plPeriodModalPl && plPeriodFilters[plPeriodModalPl]
              ? plPeriodFilters[plPeriodModalPl].keys
              : null
          }
          initialPreset={null}
          clientColor={clientColor}
          commonScopeKeys={commonScopeKeySet}
        />
        {plNameDialog}
        {detailsDrawer}
        <HelpDialog
          open={helpDialogOpen}
          setOpen={setHelpDialogOpen}
          content={[
            {
              icon: "Purpose",
              title: t("help.pl_explorer.purpose.title"),
              items: [
                {
                  title: t("help.pl_explorer.purpose.objective.title"),
                  description: t(
                    "help.pl_explorer.purpose.objective.description",
                  ),
                },
              ],
            },
            {
              icon: "BasicFunctionality",
              title: t("help.pl_explorer.basic_functionality.title"),
              items: [
                {
                  title: t(
                    "help.pl_explorer.basic_functionality.calculation_rules.title",
                  ),
                  description: t(
                    "help.pl_explorer.basic_functionality.calculation_rules.description",
                  ),
                },
                {
                  title: t(
                    "help.pl_explorer.basic_functionality.filters.title",
                  ),
                  description: t(
                    "help.pl_explorer.basic_functionality.filters.description",
                  ),
                },
                {
                  title: t(
                    "help.pl_explorer.basic_functionality.pl_naming.title",
                  ),
                  description: t(
                    "help.pl_explorer.basic_functionality.pl_naming.description",
                  ),
                },
                {
                  title: t("help.pl_explorer.basic_functionality.units.title"),
                  description: t(
                    "help.pl_explorer.basic_functionality.units.description",
                  ),
                },
                {
                  title: t(
                    "help.pl_explorer.basic_functionality.benchmarks.title",
                  ),
                  description: t(
                    "help.pl_explorer.basic_functionality.benchmarks.description",
                  ),
                },
              ],
            },
            {
              icon: "Analysis",
              title: t("help.pl_explorer.analysis.title"),
              items: [
                {
                  title: t("help.pl_explorer.analysis.how_to_open.title"),
                  description: t(
                    "help.pl_explorer.analysis.how_to_open.description",
                  ),
                },
                {
                  title: t("help.pl_explorer.analysis.calculation_logic.title"),
                  description: t(
                    "help.pl_explorer.analysis.calculation_logic.description",
                  ),
                },
                {
                  title: t(
                    "help.pl_explorer.analysis.additional_details.title",
                  ),
                  description: t(
                    "help.pl_explorer.analysis.additional_details.description",
                  ),
                },
              ],
            },
            {
              icon: "Opportunity",
              title: t("help.pl_explorer.opportunity.title"),
              items: [
                {
                  title: t("help.pl_explorer.opportunity.how_to_mark.title"),
                  description: t(
                    "help.pl_explorer.opportunity.how_to_mark.description",
                  ),
                },
                {
                  title: t(
                    "help.pl_explorer.opportunity.what_happens_after.title",
                  ),
                  description: t(
                    "help.pl_explorer.opportunity.what_happens_after.description",
                  ),
                },
              ],
            },
            {
              icon: "OtherFeatures",
              title: t("help.pl_explorer.other_features.title"),
              items: [
                {
                  title: t("help.pl_explorer.other_features.scenarios.title"),
                  description: t(
                    "help.pl_explorer.other_features.scenarios.description",
                  ),
                },
                {
                  title: t("help.pl_explorer.other_features.comparisons.title"),
                  description: t(
                    "help.pl_explorer.other_features.comparisons.description",
                  ),
                },
                {
                  title: t("help.pl_explorer.other_features.screenshot.title"),
                  description: t(
                    "help.pl_explorer.other_features.screenshot.description",
                  ),
                },
              ],
            },
          ]}
        />
      </div>
      <FullPageLoader isVisible={!metaLoaded} />
    </>
  );
}

PLExplorer.propTypes = {
  location: PropTypes.object,
};
